import cn from 'classnames';
import React from 'react';
import {useSelector} from 'react-redux';
import {RemoveScroll} from 'react-remove-scroll';

import {selectIsAnyRenderedPopup} from '../../state/selectors/modal';
import AppPopup from './AppPopup';
import styles from './Popup.module.scss';
import useOneModalOnPageAtATime from './useOneModalOnPageAtATime';

const Popup = (props) => {
    const {className, allowDisplayWithOtherPopups, overlayClassName, ...rest} = props;
    const isVisible = useOneModalOnPageAtATime({allowDisplayWithOtherPopups});
    const isAnyRenderedPopup = useSelector(selectIsAnyRenderedPopup);
    const isHidePopup = allowDisplayWithOtherPopups && isAnyRenderedPopup;
    const zIndex = isHidePopup ? '-z-10' : '';

    if (!isVisible) return null;

    return (
        <RemoveScroll enabled={!isHidePopup}>
            <AppPopup
                isOpen
                className={cn(styles.PopupContainer, className, zIndex)}
                overlayClassName={cn(styles.Overlay, overlayClassName, zIndex)}
                {...rest}
            />
        </RemoveScroll>
    );
};

export default Popup;
